/**
 * 서버 API 요청시 전체화면 Loading Overlay 시 사용합니다.
 */
export const ON_LOADING_OVERLAY_OPEN_REQUESTED = "ON_LOADING_OVERLAY_OPEN_REQUESTED";
export const ON_LOADING_OVERLAY_CLOSE_REQUESTED = "ON_LOADING_OVERLAY_CLOSE_REQUESTED";

// 시스템 관리자 권한 화면에서 사용
export const ON_SYSTEM_PERMISSION_RECEIVED = 'onSystemPermissionReceived';

// 시스템 관리자 권한 그룹에서 사용
export const ON_SYSTEM_PERMISSION_GROUP_RECEIVED = 'onSystemPermissionGroupReceived';

// 설정 관리에서 사용
export const ON_CONFIG_RECEIVED = 'ON_CONFIG_RECEIVED';

// 매뉴얼 관리에서 사용
export const ON_MANUAL_RECEIVED = 'ON_MANUAL_RECEIVED';